export const emittedNfsPtBr = {
  page: {
    title: 'Notas fiscais emitidas',
    subtitle: 'Consulte as notas emitidas e os recebíveis relacionados.',
  },
  filters: {
    title: 'Filtros',
    active: 'Filtros ativos',
    clearAll: 'Limpar todos',
    entity: 'Entidade',
    allEntities: 'Todas as entidades',
    customer: 'Cliente',
    customers: '{{count}} clientes',
    documentType: 'Tipo de documento',
    allTypes: 'Todos',
    statuses: 'Status da nota',
    selectStatuses: 'Selecione os status',
    selectedStatuses: '{{count}} selecionados',
    clearSelection: 'Limpar seleção',
    issueDate: 'Data de emissão',
    selectPeriod: 'Selecione o período',
    amount: 'Valor total',
    amountPlaceholder: '0,00',
    currency: 'Moeda',
    selectCurrency: 'Moeda',
    selectScopeForAmount: 'Selecione entidade e moeda',
    amountOperators: { eq: '=', gte: '≥', lte: '≤' },
  },
  documentTypes: { NFE: 'NF-e', NFSE: 'NFS-e', NFSE_NACIONAL: 'NFS-e Nacional', CFDI: 'CFDI' },
  statuses: {
    authorized: 'Autorizado',
    processed: 'Processado',
    manualReviewed: 'PDF conferido manualmente',
    cancelled: 'Cancelado',
    error: 'Erro',
  },
  table: {
    document: 'Documento',
    issueDate: 'Emissão',
    entity: 'Entidade',
    customer: 'Cliente',
    type: 'Tipo',
    status: 'Status',
    amount: 'Valor',
    currencyUnavailable: 'Moeda não informada',
    invoice: 'Recebível {{number}}',
    loading: 'Carregando...',
    emptyTitle: 'Nenhuma nota emitida encontrada',
    emptyDescription: 'Aplique filtros diferentes para encontrar documentos.',
    downloadPdf: 'Baixar PDF',
    pdfUnavailable: 'PDF indisponível',
    regeneratePdf: 'Regerar PDF',
    openInvoice: 'Abrir recebível',
  },
  pagination: {
    showing: 'Mostrando {{from}} a {{to}} de {{total}} itens',
    itemsPerPage: 'Itens por página:',
    option: '{{count}} / página',
    previous: 'Anterior',
    next: 'Próxima',
  },
  errors: {
    load: 'Falha ao carregar notas emitidas.',
    pdf: 'Falha ao abrir o PDF da nota.',
    regeneratePdf: 'Falha ao regerar o PDF da nota.',
  },
  messages: { pdfRegenerated: 'PDF regerado com a marca atual da entidade.' },
} as const;

export const emittedNfsEn = {
  page: {
    title: 'Issued fiscal documents',
    subtitle: 'Review issued fiscal documents and their related receivables.',
  },
  filters: {
    title: 'Filters',
    active: 'Active filters',
    clearAll: 'Clear all',
    entity: 'Entity',
    allEntities: 'All entities',
    customer: 'Customer',
    customers: '{{count}} customers',
    documentType: 'Document type',
    allTypes: 'All',
    statuses: 'Document status',
    selectStatuses: 'Select statuses',
    selectedStatuses: '{{count}} selected',
    clearSelection: 'Clear selection',
    issueDate: 'Issue date',
    selectPeriod: 'Select period',
    amount: 'Total amount',
    amountPlaceholder: '0.00',
    currency: 'Currency',
    selectCurrency: 'Currency',
    selectScopeForAmount: 'Select entity and currency',
    amountOperators: { eq: '=', gte: '≥', lte: '≤' },
  },
  documentTypes: { NFE: 'NF-e', NFSE: 'NFS-e', NFSE_NACIONAL: 'National NFS-e', CFDI: 'CFDI' },
  statuses: {
    authorized: 'Authorized',
    processed: 'Processed',
    manualReviewed: 'Manually reviewed PDF',
    cancelled: 'Cancelled',
    error: 'Error',
  },
  table: {
    document: 'Document',
    issueDate: 'Issue date',
    entity: 'Entity',
    customer: 'Customer',
    type: 'Type',
    status: 'Status',
    amount: 'Amount',
    currencyUnavailable: 'Currency unavailable',
    invoice: 'Receivable {{number}}',
    loading: 'Loading...',
    emptyTitle: 'No issued fiscal documents found',
    emptyDescription: 'Try different filters to find documents.',
    downloadPdf: 'Download PDF',
    pdfUnavailable: 'PDF unavailable',
    regeneratePdf: 'Regenerate PDF',
    openInvoice: 'Open receivable',
  },
  pagination: {
    showing: 'Showing {{from}} to {{to}} of {{total}} items',
    itemsPerPage: 'Items per page:',
    option: '{{count}} / page',
    previous: 'Previous',
    next: 'Next',
  },
  errors: {
    load: 'Failed to load issued fiscal documents.',
    pdf: 'Failed to open the document PDF.',
    regeneratePdf: 'Failed to regenerate the document PDF.',
  },
  messages: { pdfRegenerated: 'PDF regenerated with the entity’s current branding.' },
} as const;
